// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 734) return "static/chunks/06d28d30-c19cca8bb56a75f0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 977 ? "b48089e6" : chunkId) + "." + {"24":"b570d52d5833b6f7","977":"0567f53fa7728584"}[chunkId] + ".js";
};